<div class="reports-item-container">
  <ul class="list-inline section-menu-items adjust-width" #reportMenuBar>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['real-time-transactions']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Consumer Real Time Transaction'"
      >
        {{ "pages.newRetailer.realTimeTransactions" | translate }}
      </button>
    </li>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['transaction-summary']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Consumer Transaction Summary Report'"
      >
        {{ "pages.newRetailer.transactionReport" | translate }}
      </button>
    </li>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['transaction-history']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Consumer Transaction Summary Report'"
      >
        {{ "pages.newRetailer.transactionHistory" | translate }}
      </button>
    </li>

    <li
      class="list-inline-item"
      [ngStyle]="{
        display:
          userRole === 'Super Admin' ||
          userRole === 'Sub Admin' ||
          userRole === 'Billing Dept'||
          userRole === 'Admin view'
            ? 'block'
            : 'none'
      }"
    >
      <button
        mat-flat-button
        [matMenuTriggerFor]="menu"
        class="item-each"
        aria-label="Manage pricelist menu holder"
        routerLinkActive="router-link-active"
        #reportsButton
      >
        <span #reportsButtonTxt>
          {{ "pages.Billing.Billing" | translate }}
        </span>
        <i matSuffix class="mi mi-arrow-drop-down float-end"></i>
      </button>
      <mat-menu #menu="matMenu">
        <a
          mat-menu-item
          [routerLink]="['payment-report']"
          routerLinkActive="router-link-active"
          (click)="onSelectPaymentReport()"
          *hideIfUnauthorized="'Consumer Payment Report'"
        >
          {{ "pages.newRetailer.paymentReport" | translate }}
        </a>
        <!-- <a
            mat-menu-item
            [routerLink]="['invoices']"
            routerLinkActive="router-link-active"
            (click)="onSelectInvoiceReport()"
            *hideIfUnauthorized="'Invoice Report'"
            >{{ 'pages.Invoicereport.Invoicereport' | translate}}
          </a> -->
      </mat-menu>
    </li>
    

      <li
      *ngIf="isButtonDisabled"
      class="list-inline-item"

    >
      <button
        mat-flat-button
        [matMenuTriggerFor]="menu"
        class="item-each"
        aria-label="Manage pricelist menu holder"
        routerLinkActive="router-link-active"
        #reportsButton
      >
        <span #reportsButtonTxt>
          {{ "pages.Billing.Billing" | translate }}
        </span>
        <i matSuffix class="mi mi-arrow-drop-down float-end"></i>
      </button>
      <mat-menu #menu="matMenu">
        <a
          mat-menu-item
          [routerLink]="['payment-report']"
          routerLinkActive="router-link-active"
          (click)="onSelectPaymentReport()"
          *hideIfUnauthorized="'Consumer Payment Report'"
        >
          {{ "pages.newRetailer.paymentReport" | translate }}
        </a>
        <!-- <a
            mat-menu-item
            [routerLink]="['invoices']"
            routerLinkActive="router-link-active"
            (click)="onSelectInvoiceReport()"
            *hideIfUnauthorized="'Invoice Report'"
            >{{ 'pages.Invoicereport.Invoicereport' | translate}}
          </a> -->
      </mat-menu>
</li>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['consumer-acquisition']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Consumer Acquisition Report'"
      >
      {{ "pages.newRetailer.consumerAcquisition" | translate }}
      </button>
    </li>
    <li class="list-inline-item">
      <button
        mat-flat-button
        class="item-each"
        [routerLink]="['batch-export']"
        (click)="resetDropDownMenuReports()"
        routerLinkActive="router-link-active"
        *hideIfUnauthorized="'Consumer batchexport'"
      >
        {{ "pages.newRetailer.batchExport" | translate }}
      </button>
    </li>
  </ul>
  <div class="scroll-control scrl-width">
    <button
      mat-mini-fab
      id="slideLeft"
      type="button"
      class="me-3"
      (click)="onClickLeft()"
      *hideIfUnauthorized="'scrollbuttons'"
    >
      <mat-icon>arrow_left</mat-icon>
    </button>
    <button
      mat-mini-fab
      id="slideRight"
      type="button"
      (click)="onClickRight()"
      *hideIfUnauthorized="'scrollbuttons'"
    >
      <mat-icon>arrow_right</mat-icon>
    </button>
  </div>
  <router-outlet></router-outlet>
</div>
